import { SERVICE_PACKAGE } from '../products';
import ServicePackage from './components/ServicePackage';
import getIcon from './utils/icon';
export const servicePackage = {
  getIcon,
  ...SERVICE_PACKAGE
};
export default ServicePackage;
//# sourceMappingURL=index.js.map